import { render } from "./NavBar.vue?vue&type=template&id=634dc0fe&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=634dc0fe&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634dc0fe"]])

export default __exports__